import { gql } from '@common/hooks';

export const BulkUpdateSupplierDepartments = gql`
  mutation bulkUpdateSupplierDepartments(
    $input: BulkUpdateSupplierDepartmentsInput!
  ) {
    bulkUpdateSupplierDepartments(input: $input) {
      success
    }
  }
`;

export type BulkUpdateSupplierDepartmentsResponse = {
  bulkUpdateSupplierDepartments: {
    success: boolean;
  };
};

export type BulkUpdateSupplierDepartmentsVariables = {
  input: {
    organizationUnitIds: string[];
    supplierIds: string[];
    notes: string;
  };
};
